module.exports = __webpack_public_path__ + "static/media/pinned-tag-blue.154cfe71.svg";